import { IGetPayment } from "../../models/response/IPaymentResponse";

export const getPaymentListState: IGetPayment = {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
    CustomerPayment: []
}